'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = wrapAction;

var _key = require('./key');

var _key2 = _interopRequireDefault(_key);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function wrapAction(action, reducerKey) {
  return _extends({}, action, {
    meta: _extends({}, action.meta, _defineProperty({}, _key2.default, reducerKey))
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/multireducer/lib/wrapAction.js
// module id = 1156
// module chunks = 17 18 19